// extracted by mini-css-extract-plugin
export default {"numberedList":"numberedList_numberedList__mT630","numberedItem":"numberedList_numberedItem__u6zF8"};